import React, { useEffect } from 'react'
import { useAppConfigContext } from 'src/viewLayer/components/contexts/AppConfigContext'

import initZendeskWidget from './initZendeskWidget'

const DELAY_MS = 5_000 // delay loading widget for better performance

export default () => {
  const { devicePath } = useAppConfigContext()

  useEffect(() => {
    if (devicePath === 'login') {
      const timeoutReference = setTimeout(() => {
        initZendeskWidget()
      }, DELAY_MS)

      // clean up
      return () => clearTimeout(timeoutReference)
    }
  }, [devicePath])

  return <></>
}
